<template>
    <section class="section register-form">
        <div class="ingreso">
            <div class="card py-4">
                <div class="card-header-title is-size-3 pt-2 has-text-primary">
                    <h3>Regístrate</h3>
                </div>
                <div class="card-content">
                    <ValidationObserver
                        ref="observer"
                        v-slot="{ handleSubmit }"
                    >
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="name"
                                >
                                    Nombre
                                </label>
                                <Input
                                    type="text"
                                    placeholder="María Paz"
                                    name="nombre"
                                    ref="first_name"
                                    v-model="user.first_name"
                                    rules="required|min:1|max:49"
                                />
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="apellido"
                                >
                                    Apellido
                                </label>
                                <Input
                                    type="text"
                                    placeholder="Fuenzalida"
                                    name="apellido"
                                    ref="last_name"
                                    v-model="user.last_name"
                                    rules="required|min:1|max:99"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="empresa"
                                >
                                    Nombre de la Empresa
                                </label>
                                <Input
                                    type="text"
                                    placeholder="Ejemplo Ltda."
                                    name="empresa"
                                    ref="company_name"
                                    v-model="user.company_name"
                                    input-id="empresa"
                                    rules="required|min:1|max:149"
                                />
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="rut"
                                >
                                    Rut de la empresa
                                </label>
                                <Input
                                    rules="required|min:11|max:12|rut"
                                    type="text"
                                    placeholder="76.509.731-2"
                                    input-id="rut"
                                    name="rut"
                                    ref="rut"
                                    v-model="user.company_rut"
                                    v-mask="rutMask"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="email"
                                >
                                    Email
                                </label>
                                <Input
                                    type="text"
                                    placeholder="correo@ejemplo.cl"
                                    autocomplete="username"
                                    name="email"
                                    ref="email"
                                    v-model="user.email"
                                    rules="required|email|max:250"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="password"
                                >
                                    Clave
                                </label>
                                <Input
                                    rules="required|password_length"
                                    type="password"
                                    ref="password"
                                    name="password"
                                    minlength="4"
                                    maxlength="64"
                                    vid="password"
                                    v-model="user.password"
                                    autocomplete="current-password"
                                    :is-password="true"
                                    :safe-password="true"
                                />
                            </div>
                            <div class="column is-12-mobile is-half">
                                <label
                                    class="label has-text-weight-bold"
                                    for="password"
                                >
                                    Repetir Clave
                                </label>
                                <Input
                                    rules="required|confirmed:password"
                                    name="password"
                                    type="password"
                                    v-model="password_confirmation"
                                    :is-password="true"
                                />
                            </div>
                        </div>
                        <div class="is-block has-text-left mt-6 mb-6">
                            <CheckBox
                                :rules="{ required: { allowFalse: false } }"
                            >
                                <b-checkbox v-model="checkTerms">
                                    Acepto los
                                    <a
                                        :href="
                                            `http://${publicPath}/pdf/Politicas_Privacidad_CFO_App.pdf`
                                        "
                                        download
                                        target="_blank"
                                    >
                                        Términos y Condiciones
                                    </a>
                                </b-checkbox>
                            </CheckBox>
                        </div>
                        <button
                            id="continuar_button"
                            class="button is-fullwidth is-primary mb-3 mt-2"
                            :disabled="loading"
                            v-on:click.prevent="handleSubmit(submitForm)"
                        >
                            Continuar
                        </button>
                    </ValidationObserver>
                </div>
            </div>
            <p class="my-6 is-size-7">
                ¿Ya posees una cuenta?
                <a
                    class="ml-2 has-text-weight-semibold"
                    v-on:click.prevent="$router.push('/')"
                >
                    Ingresa aquí
                </a>
            </p>
        </div>
    </section>
</template>
<script>
import { downloadObligationsToSheet } from "@/api/downloadObligationsToSheet";
import CheckBox from "@/components/inputs/CheckBox";
import Input from "@/components/inputs/Input";
import { setSession } from "@/utils/auth";
import { consoleHandlerError } from "@/utils/message";
import SegmentAnalytics from "@/utils/segmentAnalytics";
import { ValidationObserver } from "vee-validate";
import { mapActions, mapMutations } from "vuex";

export default {
    name: "FormRegister",
    components: {
        Input,
        CheckBox,
        ValidationObserver,
    },
    props: {
        type: {
            type: String,
            default: "BASIC",
        },
    },
    data: function() {
        return {
            errors: [],
            checkTerms: false,
            loading: false,
            password_confirmation: "",
            user: {
                first_name: "",
                last_name: "",
                email: "",
                username: "",
                company_name: "",
                company_rut: "",
                password: "",
            },
            rutMask: ["#.###.###-B", "##.###.###-B"],
            publicPath: window.location.hostname,
        };
    },
    methods: {
        ...mapMutations("userAuth", ["SET_LOGIN"]),
        ...mapActions("userAuth", ["registerUser"]),
        submitForm() {
            if (this.loading) {
                return;
            }
            // Disable the button by setting loading to true
            this.loading = true;
            this.user.username = this.user.email;
            this.user.client_type = this.type;
            this.user.company_rut = this.user.company_rut.replaceAll(".", "");

            this.registerUser(this.user)
                .then((user) => {
                    setSession(user);
                    this.SET_LOGIN(user);
                    new SegmentAnalytics(user).trackRegisterFast();
                    downloadObligationsToSheet()
                        .then(() => {
                            if (this.type == "BASIC") {
                                this.$router.push("/dashboard");
                            } else {
                                this.$router.push("/filldata");
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            const msg =
                                "Ha ocurrido un error inesperado, contacta al equipo" +
                                " de soporte al email: hola@cforemoto.com";
                            consoleHandlerError({
                                error,
                                empty: true,
                                customDefaultMessage: msg,
                                indefinite: true,
                            });
                        });
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({
                        error,
                        refFields: this.$refs,
                    });
                });
        },
    },
};
</script>
<style scoped>
#continuar_button:disabled {
    background-color: #c0c0c0;
    color: #a0a0a0;
    cursor: not-allowed;
}
</style>
